import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
    submit(_) {
        const form = this.element;
        form.requestSubmit();
    }
}
